import Vue from "vue";
import Vuex from "vuex";
import App from "./App.vue";
import store from "./store";
import router from "./router";
import { Amplify, Analytics } from "aws-amplify";
import aws_exports from "./aws-exports";

// Configure Amplify BEFORE importing UI components
Amplify.configure(aws_exports);

import VueMeta from "vue-meta";
import vuetify from "./plugins/vuetify";
import VueI18n from "vue-i18n";
import VueRouter from "vue-router";
import translations from "./translations";
import { VueMasonryPlugin } from "vue-masonry";
import VueGtag from "vue-gtag";

import "./custom.scss";
import "@aws-amplify/ui-vue";

Analytics.autoTrack("session", {
  // REQUIRED, turn on/off the auto tracking
  enable: true,
  // OPTIONAL, the attributes of the event, you can either pass an object or a function
  // which allows you to define dynamic attributes
  attributes: {
    attr: "attr",
  },
  // when using function
  // attributes: () => {
  //    const attr = somewhere();
  //    return {
  //        myAttr: attr
  //    }
  // },
  // OPTIONAL, the service provider, by default is the Amazon Pinpoint
  provider: "AWSPinpoint",
});

Vue.config.productionTip = false;

Vue.use(Vuex);
Vue.use(VueMeta);
Vue.use(VueI18n);
Vue.use(VueRouter);
Vue.use(VueMasonryPlugin);
Vue.use(VueGtag, {
  enabled: localStorage.getItem("acceptedTerms") === "true",
  config: {
    id: process.env.VUE_APP_GTAG,
    params: {
      send_page_view: true,
    },
  },
}, router);

const messages = translations;
const i18n = new VueI18n({
  locale: "he",
  fallbackLocale: "en",
  messages,
});

new Vue({
  i18n,
  router,
  vuetify,
  store: store(Vuex),
  render: (h) => h(App),
}).$mount("#app");
